/* src/app/views/dashboard/components/sidebar-nav/side-nav-body/side-nav-body.component.scss */
:host {
  display: contents;
}
:host .side-nav-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: stretch;
  flex-grow: 1;
  overflow-y: auto;
}
:host .side-nav-body .nav-item-grouping {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: flex-start;
  align-items: stretch;
}
/*# sourceMappingURL=side-nav-body.component.css.map */
